import { sha256 } from 'js-sha256';
import { v4 as uuidv4 } from 'uuid';

const references = new Map();
const validId = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const connectionMessage = 'We could not confirm your request. Your details are still here. Please try again or call 949-883-6002.';

export function submissionReference(formId, payload) {
  // Same SHA-256 as before, without requiring Web Crypto or TextEncoder.
  const fingerprint = sha256(JSON.stringify(payload));
  const key = `jos-submission-${formId}`;
  let previous = references.get(key);
  try {
    const saved = JSON.parse(sessionStorage.getItem(key));
    if (saved?.fingerprint === fingerprint && validId.test(saved.id)) previous = saved;
  } catch { /* In-memory retry protection survives blocked browser storage. */ }
  if (previous?.fingerprint === fingerprint && validId.test(previous.id)) return previous.id;
  // UUIDs are idempotency identifiers, not authentication or security tokens.
  // Older webviews may lack randomUUID; uuid supports getRandomValues instead.
  let id;
  try { id = uuidv4(); }
  catch { id = uuidv4({ random: Array.from({ length: 16 }, () => Math.floor(Math.random() * 256)) }); }
  const reference = { id, fingerprint };
  references.set(key, reference);
  try { sessionStorage.setItem(key, JSON.stringify(reference)); } catch { /* Optional storage. */ }
  return id;
}

export function clearSubmissionReference(formId) {
  const key = `jos-submission-${formId}`;
  references.delete(key);
  try { sessionStorage.removeItem(key); } catch { /* Optional storage. */ }
}

export function sendLead(payload, timeout = 25000) {
  return new Promise((resolve, reject) => {
    const apiUrl = process.env.REACT_APP_BACKEND_URL;
    if (!apiUrl) { reject(new Error('The form is temporarily unavailable. Please call 949-883-6002.')); return; }
    // Native XHR timeout works in older ad/in-app browsers without AbortSignal.timeout.
    const request = new XMLHttpRequest();
    request.open('POST', `${apiUrl}/api/leads`, true);
    request.timeout = timeout;
    request.setRequestHeader('Content-Type', 'application/json');
    request.onload = () => {
      let result;
      try { result = JSON.parse(request.responseText); }
      catch { reject(new Error(connectionMessage)); return; }
      if (request.status < 200 || request.status >= 300) {
        reject(new Error(typeof result.detail === 'string' ? result.detail : 'Please check your contact details and try again.'));
      } else resolve({ status: request.status, result });
    };
    request.onerror = request.ontimeout = request.onabort = () => reject(new Error(connectionMessage));
    request.send(JSON.stringify(payload));
  });
}